<template>
  <v-container fluid class="form-container title">
    <div>
      <v-card-title class="form-title title">
        {{ $t("labels.settings") }} {{ $t("labels.expirationSettings") }}
      </v-card-title>
      <v-form
        class="form-body"
        @submit.prevent="onSubmit()"
        data-vv-scope="expirationSettings"
      >
        <div class="form-group required">
          <v-text-field
            :label="$t('forms.settings.notif1')"
            v-model="expirationForm.warning"
            name="warning"
          ></v-text-field>
        </div>
        <div class="form-group required">
          <v-text-field
            :label="$t('forms.settings.notif2')"
            v-model="expirationForm.expiring"
            name="expiring"
          ></v-text-field>
        </div>
        <div class="form-group required">
          <v-text-field
            :label="$t('forms.settings.notif_expired')"
            v-model="expirationForm.expired"
            name="expired"
          ></v-text-field>
        </div>
        <div class="form-group required">
          <v-text-field
            :label="$t('forms.settings.notif_validity')"
            v-model="expirationForm.validity_day_after_expiring"
            name="validity_day_after_expiring"
          ></v-text-field>
        </div>
        <div class="form-group required">
          <v-select
            v-model="expirationForm.flag_sending_expiring_email"
            :items="enabledValues"
            item-text="label"
            item-value="value"
            :label="$t('forms.settings.notif_enabled')"
            name="flag_sending_expiring_email"
          ></v-select>
        </div>
        <FormButtons
          @onSave="onSubmit"
          @onCancel="onCancel"
          :disabled="veeErrors.any('expirationSettings')"
        />
      </v-form>
    </div>
  </v-container>
</template>

<script>
import SharedMixin from "@/mixins/shared";
import Enums from "@/mixins/enums";
import FormButtons from "@/components/Shared/FormButtons";
import _ from "lodash";

export default {
  name: "ExpirationSettings",
  props: ["settings"],
  data() {
    return {
      expirationForm: {
        expiration_netsense_send_to: "",
        expiration_sfera_send_to: "",
        flag_sending_invoice_email: ""
      },
      enabledValues: [
        {
          label: this.$t("forms.settings.yes"),
          value: true
        },
        {
          label: this.$t("forms.settings.no"),
          value: false
        }
      ]
    };
  },
  components: { FormButtons },
  mixins: [SharedMixin, Enums],
  watch: {
    settings() {
      this.clearForm();
    }
  },
  methods: {
    onSubmit() {
      this.$emit("formSave", this.expirationForm);
    },
    async onCancel() {
      this.clearForm();
      this.$emit("formCancel");
    },
    clearForm() {
      if (this.settings != null)
        this.expirationForm = _.cloneDeep(this.settings);
    }
  },
  computed: {
    Enums() {
      return Enums;
    }
  },
  async created() {
    this.clearForm();
  }
};
</script>
